import { space } from 'folio-common-components';
import * as React from 'react';
import { type InputItem, PersonInput } from '../../components/PersonInput';
import { Box } from '../../components/box';
import { Button } from '../../components/buttons';
import type { Person } from '../../state/editor';
import { nameFallback } from '../../utils';

interface IncompletePersonFormProps {
  person: Person;
  inputs: InputItem[];
  onChange: (payload: Person) => void;
}

interface IncompletePersonFormState {
  person: Person;
}

export class IncompletePersonForm extends React.Component<
  IncompletePersonFormProps,
  IncompletePersonFormState
> {
  constructor(props: IncompletePersonFormProps) {
    super(props);
    this.state = {
      person: { ...props.person },
    };
  }

  render() {
    return this.props.inputs.length > 0 ? (
      <Box>
        <form
          noValidate={true}
          onSubmit={event => {
            event.preventDefault();
          }}
          data-testid="RolePersonForm"
        >
          <p>
            <b>{nameFallback(this.props.person.name)}</b> har manglende eller
            feilaktig informasjon:
          </p>
          <PersonInput
            person={this.state.person}
            inputs={this.props.inputs}
            onChange={person => this.setState({ person })}
            validate={true}
            editType="edit"
          />
          <div css={space([48], 'margin-top')}>
            <Button onClick={() => this.props.onChange(this.state.person)}>
              Lagre
            </Button>
          </div>
        </form>
      </Box>
    ) : null;
  }
}
